import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

type Props = {};

const Loader = (props: Props) => {
  return (
    <Backdrop
      open={true}
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default Loader;
